module.exports = __webpack_public_path__ + "static/work63-0238bf1b3a699c26256c7c3111821084.jpg";